export default __webpack_public_path__ + "images/05e18c7b61222ccc0f8f73eec9235352-auto.png";